import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ConditionalRender from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import {
} from '../../../utility/DateOptionUtility';
import moment from 'moment';
import convertNumberToFinancialString from '../../../utility/convertNumberToFinancialString';
import {
  ReferredTransactionType,
  ReferredTransactionTypeDetails,
} from '../../../utility/types/ReferredTransactionType';

function ReferralTransactionTable({
  fetchTransactions,
  handleTimeRangeUpdate,
  setError,
  dateValue,
  dateOptions,
}) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  React.useEffect(() => {
    setLoading(true);
    fetchTransactions()
      .then((res) => {
        const { referralTransactionList } = res;
        referralTransactionList.reverse();
        setTransactions(referralTransactionList);
        setLoading(false);
      }).catch((e) => {
        // eslint-disable-next-line no-console
        console.log('error fetching referral transactions', e);
        setError(true);
        setLoading(false);
      });
  }, [fetchTransactions, dateValue]);
  /* istanbul ignore next */
  return (
    <div className="my-3">
      <div className="clearfix text-right mt-5">
        <h5 className="float-left">Transactions</h5>
        <div className="float-right form-group row">
          <div className="form-inline col flex-nowrap">
            <select
              className="form-control w-auto"
              onChange={handleTimeRangeUpdate}
              value={dateValue}
            >
              {
                dateOptions
                  .map((date) => (
                    <option
                      key={date.id}
                      value={date.value}
                    >
                      {date.name}
                    </option>
                  ))
              }
            </select>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-striped">
          <thead>
            <tr>
              <th className="text-left">Date</th>
              <th className="text-left">Type</th>
              <th className="text-left">Details</th>
              <th className="text-left">Order Total</th>
              <th className="text-left">Earned</th>
              <th className="text-left">Balance</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((item, index) => (
              <tr key={index}>
                <td className="text-left">
                  {moment.unix(item.date).format('MMM D, YYYY')}
                </td>
                <td className="text-left">
                  { ReferredTransactionTypeDetails[item.type]
                    ? ReferredTransactionTypeDetails[item.type].displayName
                    : 'Unknown'}
                </td>
                <td className="text-left">
                  {item.details}
                </td>
                <td className="text-left">
                  {convertNumberToFinancialString(item.orderTotal)}
                </td>
                <td className="text-left">
                  {`${item.type === ReferredTransactionType.REWARD ? '-' : ''}${convertNumberToFinancialString(item.earnedTotal)}`}
                </td>
                <td className="text-left">
                  {convertNumberToFinancialString(item.runningBalance)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ConditionalRender show={loading}>
        <div className="row d-flex justify-content-center my-5">
          <div>
            <ProgressSpinner progressText="Searching..." />
          </div>
        </div>
      </ConditionalRender>

      <ConditionalRender show={(!loading && transactions.length === 0)}>
        <div className="row d-flex justify-content-center my-5">
          <div>
            <span className="alert alert-warning">No Transactions</span>
          </div>
        </div>
      </ConditionalRender>
    </div>

  );
}

ReferralTransactionTable.propTypes = {
  fetchTransactions: PropTypes.func.isRequired,
  handleTimeRangeUpdate: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  dateValue: PropTypes.number.isRequired,
  dateOptions: PropTypes.arrayOf(PropTypes.shape(
    { name: PropTypes.string, id: PropTypes.any, value: PropTypes.any },
  )).isRequired,
};

export default ReferralTransactionTable;
